import React, { PropTypes } from 'react';
import SelectField from 'material-ui/SelectField';
import {MenuItem} from 'material-ui/Menu';
import ErrorContainer from '../../../form/ErrorContainer';

class VideoCategorySelector extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    fetch: PropTypes.func.isRequired,
    error: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.fetch()
  }

  render() {
    let {
      value,
      onChange,
      items
    } = this.props;

    if(items.length > 0) {
      return (
      <ErrorContainer required={true} displayLabel={true} {...this.props}>
        <SelectField
          value={value}
          onChange={(event, index, value) => onChange(value)}
          fullWidth={true}
          required={true}
        >
          {items.map((item, index) => (
            <MenuItem
              key={index}
              value={item.id}
              primaryText={item.name}
            />
          ))}
        </SelectField>
      </ErrorContainer>
      );
    } else {
      return (<div style={{ marginBottom: 14, fontWeight: 'bold' }}></div>);
    }
  }
}

export default VideoCategorySelector;




// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoCategorySelector/component.jsx